import { Alert, Snackbar } from '@mui/material';
import { motion, useReducedMotion } from 'motion/react';
import { useUiStore } from '@/store/uiStore';
import { toastVariants } from '@/animation/variants';

export function AppToaster() {
  const toast = useUiStore((s) => s.toast);
  const hideToast = useUiStore((s) => s.hideToast);
  const shouldReduceMotion = useReducedMotion();

  return (
    <Snackbar
      open={toast.open}
      autoHideDuration={4500}
      onClose={hideToast}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        bottom: {
          xs: 'calc(var(--bottom-nav-height, 64px) + env(safe-area-inset-bottom, 0px) + 14px) !important',
          sm: '24px !important',
        },
        left: { xs: '16px !important', sm: 'auto !important' },
        right: { xs: '16px !important', sm: '24px !important' },
        margin: '0 auto',
        maxWidth: { xs: 'calc(100% - 32px)', sm: 440 },
        zIndex: (theme) => theme.zIndex.snackbar + 10,
        pointerEvents: 'none',
      }}
    >
      <motion.div
        variants={toastVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        style={shouldReduceMotion ? { width: '100%', pointerEvents: 'auto' } : { width: '100%', pointerEvents: 'auto' }}
      >
        <Alert
          onClose={hideToast}
          severity={toast.severity}
          variant="filled"
          sx={{
            width: '100%',
            borderRadius: '8px',
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
            fontWeight: 600,
            fontSize: '0.85rem',
            py: 1,
            px: 2,
            alignItems: 'center',
            '&.MuiAlert-filledSuccess': {
              bgcolor: '#00B894',
              color: '#FFFFFF',
            },
            '& .MuiAlert-icon': {
              fontSize: '1.25rem',
              mr: 1.25,
              color: '#FFFFFF',
            },
            '& .MuiAlert-message': {
              py: 0,
              fontSize: '0.85rem',
              lineHeight: 1.35,
            },
            '& .MuiAlert-action': {
              pl: 1,
              pt: 0,
              color: '#FFFFFF',
              '& .MuiIconButton-root': {
                color: '#FFFFFF',
                p: 0.5,
              },
            },
          }}
        >
          {toast.message}
        </Alert>
      </motion.div>
    </Snackbar>
  );
}


